export const VimplayData = {
  vimplay1: {
    redirectUrl: "/casino/vimplayvimplay-techno-roulette",
    imgUrl: "./images/vimplay/TECHNOROULETTE.webp",
    name: "TECHNO ROULETTE",
  },
  vimplay2: {
    redirectUrl: "/casino/vimplayvimplay-royal-roulette",
    imgUrl: "./images/vimplay/ROYALROULETTE.webp",
    name: "ROYAL ROULETTE",
  },
  vimplay3: {
    redirectUrl: "/casino/vimplayvimplay-replay-roulette",
    imgUrl: "./images/vimplay/REPLAYROULETTE.webp",
    name: "REPLAY ROULETTE",
  },
  vimplay4: {
    redirectUrl: "/casino/vimplayvimplay-cosmic-roulette",
    imgUrl: "./images/vimplay/COSMICROULETTE.webp",
    name: "COSMIC ROULETTE",
  },
  vimplay5: {
    redirectUrl: "/casino/vimplayvimplay-rouletto",
    imgUrl: "./images/vimplay/ROULETTO.webp",
    name: "ROULETTO",
  },
  vimplay6: {
    redirectUrl: "/casino/vimplayvimplay-bombrunner",
    imgUrl: "./images/vimplay/BOMBRUNNER.webp",
    name: "BOMB_RUNNER",
  },
  vimplay7: {
    redirectUrl: "/casino/vimplayvimplay-wishingwell",
    imgUrl: "./images/vimplay/WISHINGWELL.webp",
    name: " WISHING_WELL",
  },
  vimplay8: {
    redirectUrl: "/casino/vimplayvimplay-crash-kick",
    imgUrl: "./images/vimplay/CRASHKICK.webp",
    name: "CRASH KICK",
  },
  vimplay9: {
    redirectUrl: "/casino/vimplayvimplay-lottoluck",
    imgUrl: "./images/vimplay/LOTTOLUCK.webp",
    name: "LOTTO_LUCK",
  },
  vimplay10: {
    redirectUrl: "/casino/vimplayvimplay-dragontap",
    imgUrl: "./images/vimplay/DRAGONTAP.webp",
    name: "DRAGON_TAP",
  },
  vimplay11: {
    redirectUrl: "/casino/vimplayvimplay-hotorcold",
    imgUrl: "./images/vimplay/HOTORCOLD.webp",
    name: "HOT_OR_COLD",
  },
  vimplay12: {
    redirectUrl: "/casino/vimplayvimplay-fate-flip",
    imgUrl: "./images/vimplay/FATEFLIP.webp",
    name: "FATE FLIP",
  },
  vimplay13: {
    redirectUrl: "/casino/vimplayvimplay-spinnywinny",
    imgUrl: "./images/vimplay/SPINNYWINNY.webp",
    name: "SPINNY_WINNY",
  },
  vimplay14: {
    redirectUrl: "/casino/vimplayvimplay-tossboss",
    imgUrl: "./images/vimplay/TOSSBOSS.webp",
    name: "TOSS_BOSS",
  },
  vimplay15: {
    redirectUrl: "/casino/vimplayvimplay-paradice",
    imgUrl: "./images/vimplay/PARADICE.webp",
    name: "PARADICE",
  },
  vimplay16: {
    redirectUrl: "/casino/vimplayvimplay-piratemines",
    imgUrl: "./images/vimplay/PIRATEMINES.webp",
    name: "PIRATE_MINES",
  },
  vimplay17: {
    redirectUrl: "/casino/vimplayvimplay-space-raiders",
    imgUrl: "./images/vimplay/SpaceRaiders.webp",
    name: "Space Raiders",
  },
  vimplay18: {
    redirectUrl: "/casino/vimplayvimplay-aladdin",
    imgUrl: "./images/vimplay/ALADDIN.webp",
    name: "ALADDIN",
  },
  vimplay19: {
    redirectUrl: "/casino/vimplayvimplay-tinyroulette",
    imgUrl: "./images/vimplay/TINYROULETTE.webp",
    name: "TINY_ROULETTE",
  },
  vimplay20: {
    redirectUrl: "/casino/vimplayvimplay-luckyline",
    imgUrl: "./images/vimplay/LUCKYLINE.webp",
    name: "LUCKY_LINE",
  },
  vimplay21: {
    redirectUrl: "/casino/vimplayvimplay-diamondmine",
    imgUrl: "./images/vimplay/DIAMONDMINE.webp",
    name: "DIAMOND_MINE",
  },
  vimplay22: {
    redirectUrl: "/casino/vimplayvimplay-aquakeno",
    imgUrl: "./images/vimplay/AQUAKENO.webp",
    name: "AQUA_KENO",
  },
};
